import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FaqResult } from 'app/models/help/help.models';
import { Observable } from 'rxjs';

import { AppConfig } from '../app.config';
import { CurrentQuestionnaireService } from './current-questionnaire.service';

@Injectable()
export class HelpService {
  constructor(
    private http: HttpClient,
    private currentQuestionnaire: CurrentQuestionnaireService
  ) {}

  getFaq(): Observable<FaqResult> {
    let url = AppConfig.ApiUrl + `user/faq`;
    return this.http.get<FaqResult>(url);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/help.service.ts